import { render, staticRenderFns } from "./SaleChannelSelect.vue?vue&type=template&id=d50eaafc&"
import script from "./SaleChannelSelect.vue?vue&type=script&lang=js&"
export * from "./SaleChannelSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports